<template>
  <!--底部-->
  <div>
    <div class="bottom_pc">
      <div class="bottom_list">
        <div class="bottom_list_info">
          <div class="bottom_list_info_box">
            <div>
              <span class="bottom_list_info_num">60</span>
              <span class="bottom_list_info_unit">个</span>
            </div>
            <div class="bottom_list_info_title">软件著作权</div>
          </div>
        </div>
        <div class="bottom_list_info">
          <div class="bottom_list_info_box">
            <div>
              <span class="bottom_list_info_num">4</span>
              <span class="bottom_list_info_unit">项</span>
            </div>
            <div class="bottom_list_info_title">发明专利</div>
          </div>
        </div>
        <div class="bottom_list_info">
          <div class="bottom_list_info_box">
            <div>ISO9001</div>
            <div class="bottom_list_info_title">认证</div>
          </div>
        </div>
        <div class="bottom_list_info">
          <div class="bottom_list_info_box">
            <div>CMMI3</div>
            <div class="bottom_list_info_title">认证</div>
          </div>
        </div>
        <div class="bottom_list_info">
          <div class="bottom_list_info_box">
            <div>高新技术企业</div>
            <div class="bottom_list_info_title">认证</div>
          </div>
        </div>
      </div>
      <div class="bottom_tab">
        <div>
          <img src="@/asstes/home/logo_white.png" />
        </div>
        <div class="bottom_info">
          <div class="bottom_info_list">
            <div class="bottom_info_list_title">快速入口</div>
            <div class="bottom_info_list_tab">
              <span @click="handlejump(1)" style="cursor: pointer"
                >解决方案</span
              >
            </div>
            <div class="bottom_info_list_tab">
              <span @click="handlejump(2)" style="cursor: pointer"
                >客户案例</span
              >
            </div>
            <div class="bottom_info_list_tab">
              <span @click="handlejump(3)" style="cursor: pointer"
                >关于我们</span
              >
            </div>
          </div>
          <div class="bottom_info_list">
            <div class="bottom_info_list_title">合作网站</div>
            <div class="bottom_info_list_tab">挚达科技</div>
            <div class="bottom_info_list_tab">无锡挚达数智</div>
          </div>
          <div class="bottom_info_list">
            <div class="bottom_info_list_title">联系我们</div>
            <div class="bottom_info_list_tab">电话：0510-81819998</div>
            <div class="bottom_info_list_tab">邮箱：service_xc@wxzhida.cn</div>
            <div class="bottom_info_list_tab">
              地址：无锡市经济开发区清舒道60号海归小镇2号楼202室
            </div>
          </div>
        </div>
      </div>
      <div class="filingInfo">
        <div>© 2017 无锡挚达数智科技有限公司版权所有</div>
        <div class="link">
          <span @click="linkto">
            <img src="@/asstes/home/record.png" /> 苏公网安备
            32021302000544号&nbsp;&nbsp;&nbsp;&nbsp;苏ICP备18008941号-1
          </span>
        </div>
      </div>
    </div>
    <div class="bottom_app">
      <div class="bottom_app_info">
        <div>© 2017 无锡挚达数智科技有限公司版权所有</div>
        <div class="link" @click="linkto">
          <div>
            <img src="@/asstes/home/record.png" />
            <span>苏公网安备 32021302000544号</span>
          </div>
          <div>苏ICP备18008941号-1</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    linkto() {
      window.open("http://beian.miit.gov.cn/", "_blank");
    },
    handlejump(val) {
      let that = this;
      if (val === 1) that.$router.push({ path: "/solution" });
      if (val === 2) that.$router.push({ path: "/customerCase" });
      if (val === 3) that.$router.push({ path: "/aboutUs" });
    },
  },
};
</script>

<style lang="less" scoped>
@media only screen and (max-width: 750px) {
  .bottom_pc {
    display: none;
  }
  .bottom_app {
    text-align: center;
    background-color: white;
    padding: 120px 0 80px 0;
    .bottom_app_info {
      line-height: 64px;
      font-width: 400;
      font-size: 32px;
      .link {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        padding-top: 32px;
        box-sizing: border-box;
        color: #939393;
        div:first-child {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding-bottom: 16px;
          box-sizing: border-box;
          img {
            padding-right: 16px;
            box-sizing: border-box;
          }
        }
        div:last-child {
          width: 100%;
        }
      }
    }
  }
}
@media only screen and (min-width: 750px) {
  .bottom_pc {
    width: 100%;
    background-color: #5d5f70;
    color: white;

    .bottom_list {
      background-color: rgba(216, 216, 216, 0.09);
      padding: 24px 120px;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;

      .bottom_list_info {
        .bottom_list_info_box {
          width: 120px;
          font-size: 14px;
        }

        .bottom_list_info_title {
          padding-top: 8px;
          box-sizing: border-box;
          font-size: 12px;
        }

        .bottom_list_info_num {
          font-size: 17px;
          padding-right: 3%;
          box-sizing: border-box;
        }

        .bottom_list_info_unit {
          font-size: 8px;
        }
      }
    }

    .bottom_list > div {
      width: 20%;
    }

    .bottom_tab {
      display: flex;
      padding: 80px 120px 80px 120px;
      box-sizing: border-box;

      .bottom_info {
        width: 100%;
        padding-left: 148px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;

        .bottom_info_list {
          width: 33.33%;

          .bottom_info_list_title {
            font-size: 14px;
            padding-bottom: 24px;
            box-sizing: border-box;
          }

          .bottom_info_list_tab {
            font-size: 12px;
            padding-bottom: 24px;
            box-sizing: border-box;
          }
        }
      }
    }

    .filingInfo {
      width: 100%;
      padding: 0 120px 24px 120px;
      box-sizing: border-box;
      font-size: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      div:first-child {
        width: 100%;
        text-align: center;
        padding-bottom: 8px;
        box-sizing: border-box;
      }

      .link {
        width: 100%;
        text-align: center;
        color: #939393;
        line-height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        span {
          display: flex;
          align-items: center;
          img {
            width: 20px;
            height: 20px;
            padding: 0 8px;
          }
        }
        span:hover {
          cursor: pointer;
        }
      }
    }
  }

  .bottom_app {
    display: none;
  }
}
</style>
